/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { LOADING_TYPE } from './defs';

/**
 * @deprecated Use `defs.ts`
 */
export default LOADING_TYPE;
